<template>
<div class="daoh2">
    <div class="ti">
      <router-view></router-view>
    </div>
</div>
</template>
<script>
export default {
  name: 'CardIndex',
  data () {
    return {
      isCollapse: false,
      item:[],
      activeIndex: '1010401',
      items_list1:[
          {
            id:'1010401',
            label: '会员管理',
            icon: 'mdi-home-outline ',
            path:'/Card/User',
            pid:101040,
          },
      ],
    }
  },
  //界面没出来前加载
  created() {
    this.$myhttp.get('admin/lavel2?pid=101020',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        if(backdata.data != 1){
          this.item = backdata.data;
        }else{
          this.item = this.items_list1;
        }
        // console.log(backdata.data)
      });
  },
}
</script>
<style scoped>
.daoh2{
    display: flex;
    height: 100%;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 130px;
  height: 100%;
}
a{
    text-decoration: none;
 }
.ti{
  height: 100%;
  width: 100%;
  background-color: white;
}

.router-link-active {

}

</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/Index.vue